import React, { useState, useEffect } from "react";
import { Button, Space, Select, message } from "antd";
import axios from "axios";
import { mainUrl } from "../../helpers/constants";
import { ILabel } from "../../types";
import { MinusOutlined } from "@ant-design/icons";

interface IProps {
  selectedSiteIds: string[];
  onSuccess: () => void;
}

export const RemoveLabelsFromSites: React.FC<IProps> = ({
  selectedSiteIds,
  onSuccess,
}) => {
  const [selectedLabels, setSelectedLabels] = useState<string[]>([]);
  const [availableLabels, setAvailableLabels] = useState<ILabel[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedSiteIds.length > 0) {
      loadLabelsForSites();
    }
  }, [selectedSiteIds]);

  const loadLabelsForSites = async () => {
    try {
      const token = localStorage.getItem("token");
      const instance = axios.create({
        baseURL: mainUrl,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const res = await instance.post<any>("api/v1/label/get-for-sites", {
        siteIds: selectedSiteIds,
      });

      if (res.data.status === "success") {
        setAvailableLabels(res.data.labels || []);
      }
    } catch (error) {
      console.error("Error loading labels for sites:", error);
    }
  };

  const handleRemoveLabels = async () => {
    if (selectedLabels.length === 0) {
      message.error("Выберите хотя бы одну метку для удаления");
      return;
    }

    if (selectedSiteIds.length === 0) {
      message.error("Выберите хотя бы один сайт");
      return;
    }

    setIsLoading(true);

    try {
      const token = localStorage.getItem("token");
      const instance = axios.create({
        baseURL: mainUrl,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const res = await instance.post<any>("api/v1/label/remove-from-sites", {
        siteIds: selectedSiteIds,
        labelIds: selectedLabels,
      });

      if (res.data.status === "success") {
        message.success(res.data.message || "Метки успешно удалены");
        setSelectedLabels([]);
        setAvailableLabels([]);
        onSuccess();
      }
    } catch (error) {
      console.error("Error removing labels:", error);
      message.error("Ошибка при удалении меток");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveAllLabels = async () => {
    if (selectedSiteIds.length === 0) {
      message.error("Выберите хотя бы один сайт");
      return;
    }

    setIsLoading(true);

    try {
      const token = localStorage.getItem("token");
      const instance = axios.create({
        baseURL: mainUrl,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const res = await instance.post<any>("api/v1/label/remove-all-from-sites", {
        siteIds: selectedSiteIds,
      });

      if (res.data.status === "success") {
        message.success(res.data.message || "Все метки успешно удалены");
        setSelectedLabels([]);
        setAvailableLabels([]);
        onSuccess();
      }
    } catch (error) {
      console.error("Error removing all labels:", error);
      message.error("Ошибка при удалении всех меток");
    } finally {
      setIsLoading(false);
    }
  };

  if (selectedSiteIds.length === 0) {
    return null;
  }

  return (
    <div className="panel-orange" style={{ marginBottom: 16, padding: 16 }}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <div>
          Выбрано сайтов: <strong>{selectedSiteIds.length}</strong>
        </div>
        {availableLabels.length > 0 ? (
          <>
            <Space>
              <Select
                mode="multiple"
                placeholder="Выберите метки для удаления"
                value={selectedLabels}
                onChange={setSelectedLabels}
                style={{ width: 300 }}
                options={availableLabels.map((label) => ({
                  value: label._id,
                  label: label.name,
                }))}
              />
              <Button
                danger
                onClick={handleRemoveLabels}
                loading={isLoading}
                disabled={selectedLabels.length === 0}
              >
                <MinusOutlined /> Удалить выбранные метки
              </Button>
              <Button
                danger
                type="primary"
                onClick={handleRemoveAllLabels}
                loading={isLoading}
              >
                Удалить все метки
              </Button>
            </Space>
          </>
        ) : (
          <div style={{ color: "#999" }}>
            У выбранных сайтов нет меток для удаления
          </div>
        )}
      </Space>
    </div>
  );
};
